<template>
 <div>
	<el-table :data='tableData' stripe style="width: 100%" :height="380" class="infinite-table-RISK">
		<el-table-column
		type="index"
		width="50">
		</el-table-column>
		<el-table-column prop="chrId" label="CHR_ID" min-width="90" >
		</el-table-column>
		<el-table-column prop="chrPos" label="CHR_POS" min-width="110">
		</el-table-column>
		<el-table-column prop="snps" label="SNPS" min-width="120">
		</el-table-column>
		<el-table-column prop="gene" label="Gene" min-width="120">
		</el-table-column>
		<el-table-column prop="refAlelle" label="Ref Alelle" min-width="100">
		</el-table-column>
		<el-table-column prop="snp" label="SNP" min-width="70">
		</el-table-column>
		<el-table-column prop="riskAllele" label="Risk Allele" min-width="105">
		</el-table-column>
		<el-table-column prop="riskHomo" label="Risk homo" min-width="105">
		</el-table-column>
		<el-table-column prop="riskHomoFreq" label="Risk homo freq" min-width="135">
		</el-table-column>
		<el-table-column prop="riskHomoOr" label="Risk homo OR" min-width="130">
		</el-table-column>
		<el-table-column prop="riskHomoRiskM" label="Risk homo risk (M)" min-width="160">
		</el-table-column>
		<el-table-column prop="riskHomoOrM" label="Risk homo OR@ (M)" min-width="165">
		</el-table-column>
		<el-table-column prop="riskHomoRiskF" label="Risk homo risk (F)" min-width="160">
		</el-table-column>
		<el-table-column prop="riskHomoOrF" label="Risk homo OR@ (F)" min-width="160">
		</el-table-column>
		<el-table-column prop="hetero" label="Hetero" min-width="90">
		</el-table-column>
		<el-table-column prop="heteroFreq" label="Hetero freq" min-width="115">
		</el-table-column>
		<el-table-column prop="heteroOr" label="Hetero OR" min-width="110">
		</el-table-column>
		<el-table-column prop="heteroRiskM" label="Hetero risk (M)" min-width="140">
		</el-table-column>
		<el-table-column prop="heteroOrM" label="Hetero OR@ (M)" min-width="145">
		</el-table-column>
		<el-table-column prop="heteroRiskF" label="Hetero risk (F)" min-width="130">
		</el-table-column>
		<el-table-column prop="heteroOrF" label="Hetero OR@ (F)" min-width="140">
		</el-table-column>
		<el-table-column prop="wtHomo" label="WT homo" min-width="100">
		</el-table-column>
		<el-table-column prop="wtHomoFreq" label="WT homo freq" min-width="135">
		</el-table-column>
		<el-table-column prop="wtHomoOr" label="WT homo OR" min-width="130">
		</el-table-column>
		<el-table-column prop="wtHomoRiskM" label="WT homo risk (M)" min-width="155">
		</el-table-column>
		<el-table-column prop="wtOrM" label="WT OR@ (M)" min-width="130">
		</el-table-column>
		<el-table-column prop="wtHomoRiskF" label="WT homo risk (F)" min-width="150">
		</el-table-column>
		<el-table-column prop="wtOrF" label="WT OR@ (F)" min-width="130">
		</el-table-column>
		<el-table-column prop="ldBlock" label="LD block" min-width="100">
		</el-table-column>
		<template slot="append">
			<slot/>
		</template>
	</el-table>
</div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>

</style>
